import React from 'react';
import {CommonCreate} from '../Common';
import {getInputs} from './Common';

export const ContractIndexValueCreate = props => (
  <CommonCreate {...props} fields={getInputs()} />
);
